import TicketStatus from "../ticket-status/ticket-status.model";

export default class TicketStatusStat {
    public ticketStatus: TicketStatus = new TicketStatus();
    public count: number = 0;
    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.ticketStatus) {
            this.ticketStatus = new TicketStatus(model.ticketStatus);
        }
        if (model.count) {
            this.count = Number(model.count);
        }
    }

    public apiObject() {
        return {
            ticketStatus: this.ticketStatus,
            count: this.count
        };
    }
}